import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { IClassroom, IClassroomMetrics } from "../types";

export type IClassroomMetricsQueryParameters = {
    classroom?: RelationalFilter<IClassroom>;
};

export type IClassroomMetricsQueryResult = IClassroomMetrics;

export const classroomMetricsQuery: IApiQueryFunction<IClassroomMetricsQueryParameters> = ({ classroom }) => {
    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/classrooms/${mapRelationalFilter(classroom)}/metrics`,
    };
};

export const useClassroomMetricsQuery = createApiQueryHook<
    IClassroomMetricsQueryParameters,
    IClassroomMetricsQueryResult
>(classroomMetricsQuery);
